import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import '../styles/LoginPage.css';

const LoginPage = () => {
  const [form, setForm]         = useState({ email: '', password: '' });
  const [isLoading, setLoading] = useState(false);
  const [error, setError]       = useState('');

  const { login }  = useAdminAuth();
  const navigate   = useNavigate();

  // Redirect based on admin role after login
  const getDefaultRoute = (adminUser) => {
    switch (adminUser?.admin_role) {
      case 'super_admin':      return '/';
      case 'project_reviewer': return '/reviews';
      case 'support_agent':    return '/users';
      case 'marketing':        return '/';
      default:                 return '/';
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(form);

    if (result.success) {
      // Read the stored admin_user to determine role-based redirect
      try {
        const savedUser = JSON.parse(localStorage.getItem('admin_user'));
        navigate(getDefaultRoute(savedUser));
      } catch {
        navigate('/');
      }
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <span className="login-icon">🛡️</span>
          <h1 className="login-title">Admin Portal</h1>
          <p className="login-subtitle">Restricted access — authorized personnel only</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && (
            <div className="error-box">
              <span>⚠️</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label" htmlFor="email">Email Address</label>
            <input
              className="form-input"
              type="email"
              id="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="admin@example.com"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">Password</label>
            <input
              className="form-input"
              type="password"
              id="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>

          <button className="login-btn" type="submit" disabled={isLoading}>
            {isLoading ? (
              <><span className="spinner" /> Authenticating…</>
            ) : (
              'Sign in to Admin Panel'
            )}
          </button>
        </form>

        <p className="login-footer">
          © {new Date().getFullYear()} BATOS IT SOLUTIONS. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
